export default __webpack_public_path__ + "static/media/ticketlogo.d83ab690.svg";